import React from 'react';

const ReturnCancelPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">
            İade ve İptal Koşulları
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <h2 className="text-xl font-semibold mb-4">1. GENEL BİLGİLER</h2>
            <p className="mb-4">
              Bu sayfa, Fiel Home'dan satın aldığınız ürünlerin iade ve iptal 
              koşullarını açıklamaktadır. 6502 sayılı Tüketicinin Korunması 
              Hakkında Kanun çerçevesinde hazırlanmıştır.
            </p>
            
            <div className="bg-gray-100 p-4 rounded-lg mb-6">
              <h3 className="text-lg font-semibold mb-2">İletişim Bilgileri</h3>
              <p><strong>Fiel Home</strong></p>
              <p>MAHMUDİYE MAH. ERTUĞRUL GAZİ CAD. NO: 46 A İNEGÖL/BURSA</p>
              <p>Telefon: +90 552 229 90 07</p>
              <p>E-posta: info@fielhome.com</p>
            </div>
            
            <h2 className="text-xl font-semibold mb-4">2. CAYMA HAKKI</h2>
            <h3 className="text-lg font-semibold mb-3">2.1. Cayma Hakkı Süresi</h3>
            <p className="mb-4">
              Ürün teslim tarihinden itibaren <strong>14 gün</strong> içinde 
              herhangi bir gerekçe göstermeksizin sözleşmeden cayabilirsiniz.
            </p>
            
            <h3 className="text-lg font-semibold mb-3">2.2. Cayma Hakkının Kullanılması</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Cayma bildirimini yazılı olarak yapmalısınız</li>
              <li>E-posta, telefon veya iade formu ile bildirim yapabilirsiniz</li>
              <li>Ürünü orijinal ambalajında ve kullanılmamış olarak iade etmelisiniz</li>
              <li>İade kargo ücreti size aittir</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">3. İADE EDİLEBİLİR ÜRÜNLER</h2>
            <h3 className="text-lg font-semibold mb-3">3.1. İade Edilebilir Ürünler</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Orijinal ambalajında olan ürünler</li>
              <li>Kullanılmamış ve zarar görmemiş ürünler</li>
              <li>Tüm aksesuarları ve parçaları eksiksiz olan ürünler</li>
              <li>Hijyen bandı çıkarılmamış ürünler (yatak, yastık vb.)</li>
            </ul>
            
            <h3 className="text-lg font-semibold mb-3">3.2. İade Edilemeyen Ürünler</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Kişiye özel üretilen mobilyalar</li>
              <li>Ölçüye özel kesilmiş ürünler</li>
              <li>Montajı yapılmış ve kullanılan mobilyalar</li>
              <li>Hijyen açısından iade edilmesi uygun olmayan ürünler</li>
              <li>Özel sipariş üzerine getirilen ürünler</li>
              <li>Zarar görmüş veya kirlenmiş ürünler</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">4. İADE SÜRECİ</h2>
            <h3 className="text-lg font-semibold mb-3">4.1. İade Başvurusu</h3>
            <ol className="list-decimal list-inside mb-4 space-y-2">
              <li>Müşteri hizmetlerimizi arayın: +90 552 229 90 07</li>
              <li>E-posta gönderin: info@fielhome.com</li>
              <li>Web sitemizden iade formu doldurun</li>
              <li>İade numaranızı alın</li>
            </ol>
            
            <h3 className="text-lg font-semibold mb-3">4.2. Ürün İadesi</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Ürünü orijinal ambalajında paketleyin</li>
              <li>İade numaranızı pakete yazın</li>
              <li>Kargo ile şu adrese gönderin: MAHMUDİYE MAH. ERTUĞRUL GAZİ CAD. NO: 46 A İNEGÖL/BURSA</li>
              <li>Kargo takip numarasını saklayın</li>
            </ul>
            
            <h3 className="text-lg font-semibold mb-3">4.3. İnceleme ve Onay</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Ürün tarafımıza ulaştıktan sonra 3 iş günü içinde incelenir</li>
              <li>İade koşullarına uygunsa onaylanır</li>
              <li>Uygun değilse ürün size geri gönderilir</li>
              <li>İade durumu e-posta ile bildirilir</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">5. PARA İADESİ</h2>
            <h3 className="text-lg font-semibold mb-3">5.1. İade Süreci</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>İade onaylandıktan sonra 10 iş günü içinde ödeme iadesi yapılır</li>
              <li>Kredi kartı ile yapılan ödemeler kartınıza iade edilir</li>
              <li>Havale ile yapılan ödemeler banka hesabınıza iade edilir</li>
              <li>Nakit ödemeler banka hesabınıza transfer edilir</li>
            </ul>
            
            <h3 className="text-lg font-semibold mb-3">5.2. İade Tutarı</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Ürün bedeli tam olarak iade edilir</li>
              <li>İlk kargo ücreti (varsa) iade edilir</li>
              <li>İade kargo ücreti müşteriye aittir</li>
              <li>Taksitli alımlarda taksit sayısına göre iade yapılır</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">6. DEĞİŞİM</h2>
            <h3 className="text-lg font-semibold mb-3">6.1. Değişim Koşulları</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Aynı kategorideki ürünlerle değişim yapılabilir</li>
              <li>Fiyat farkı varsa ek ödeme yapılır</li>
              <li>Fiyat farkı geri iade durumunda iade edilir</li>
              <li>Değişim sadece 1 kez yapılabilir</li>
            </ul>
            
            <h3 className="text-lg font-semibold mb-3">6.2. Değişim Süreci</h3>
            <ol className="list-decimal list-inside mb-4 space-y-2">
              <li>Değişim talebini bildirin</li>
              <li>Yeni ürünü seçin</li>
              <li>Eski ürünü iade edin</li>
              <li>Yeni ürün size gönderilir</li>
            </ol>
            
            <h2 className="text-xl font-semibold mb-4">7. GARANTİLİ İADE</h2>
            <h3 className="text-lg font-semibold mb-3">7.1. Arızalı Ürün İadesi</h3>
            <p className="mb-4">
              Satın aldığınız ürün arızalı çıkarsa:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Ücretsiz olarak iade edilir</li>
              <li>Kargo ücretleri tarafımızca karşılanır</li>
              <li>Yeni ürün gönderilir veya para iadesi yapılır</li>
              <li>Tazminat hakkı doğabilir</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">8. ÖZEL DURUMLAR</h2>
            <h3 className="text-lg font-semibold mb-3">8.1. Büyük Mobilyalar</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Montajlı mobilyaların iadesi için demontaj gerekir</li>
              <li>Demontaj ücreti müşteriye aittir</li>
              <li>Montaj sırasında zarar gören ürünler iade edilemez</li>
              <li>Ölçü hataları müşteri sorumluluğundadır</li>
            </ul>
            
            <h3 className="text-lg font-semibold mb-3">8.2. Kumaş ve Renk Farkları</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>%10'a kadar renk farkı normaldir</li>
              <li>Doğal kumaşlarda desen farklılıkları olabilir</li>
              <li>Monitör ayarlarından kaynaklanan farklar kabul edilmez</li>
              <li>Numune ile uyumsuzluk iade sebebidir</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">9. MÜŞTERI HİZMETLERİ</h2>
            <p className="mb-4">
              İade ve değişim işlemleriniz için:
            </p>
            <div className="bg-blue-50 p-4 rounded-lg">
              <p><strong>Telefon:</strong> +90 552 229 90 07 (Hafta içi 09:00-18:00)</p>
              <p><strong>E-posta:</strong> info@fielhome.com</p>
              <p><strong>Adres:</strong> MAHMUDİYE MAH. ERTUĞRUL GAZİ CAD. NO: 46 A İNEGÖL/BURSA</p>
              <p><strong>Çalışma Saatleri:</strong> Pazartesi-Cuma 09:00-18:00</p>
            </div>
            
            <p className="mt-8 text-sm text-gray-600">
              Bu koşullar {new Date().toLocaleDateString('tr-TR')} tarihinde güncellenmiştir.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnCancelPage;
